import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import getLocale from '../../../i18n/getLocale';

require('moment');
require('moment/locale/pt-br');

class AircraftModelVersionCustomItemsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_model_id: this.props.aircraft_model_id,
      aircraft_model_version_id: this.props.aircraft_model_version_id,
      id: null,
      name: '',
      type: '',
      itens_list: [],
      options: [''],
    };
    this.locale = getLocale();
    this.updateData = this.updateData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.addOptionRow = this.addOptionRow.bind(this);
    this.removeOptionRow = this.removeOptionRow.bind(this);
  }

  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
      if (name === 'type') {
        change['options'] = [];
      }
    } else {
      change[name] = event.value;
      if (name === 'type') {
        change['options'] = event.value === 'options' ? [''] : [];
      }
    }
    this.setState(change);
  }

  handleToggleChange(name, event) {
    var change = {};
    var value = event.target.checked === true ? 1 : 0;
    change[name] = value;
    this.setState(change);
  }

  handleOptionChange(index, event) {
    var options = (this.state.options || []).slice();
    options[index] = event.target.value;
    this.setState({ options });
  }

  addOptionRow() {
    var options = (this.state.options || []).slice();
    options.push('');
    this.setState({ options });
  }

  removeOptionRow(index) {
    var options = (this.state.options || []).slice();
    if (options.length <= 1) {
      options = [''];
    } else {
      options.splice(index, 1);
    }
    this.setState({ options });
  }

  componentWillReceiveProps(newProps) {
    if (this.state.loaded === 0) {
      this.setState({ loaded: 1 }, this.loadData());
    }
    if (
      typeof newProps.aircraft_model_id !== 'undefined' &&
      newProps.aircraft_model_id !== null &&
      this.state.loaded === 1
    ) {
      this.setState({ aircraft_model_id: newProps.aircraft_model_id });
    }
    if (
      typeof newProps.aircraft_model_version_id !== 'undefined' &&
      newProps.aircraft_model_version_id !== null &&
      this.state.loaded === 1
    ) {
      this.setState({ aircraft_model_version_id: newProps.aircraft_model_version_id });
    }
  }

  updateData(responseJson) {
    this.setState({ updated: 1 }, this.loadData(responseJson));
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function (value) {
      var url =
        config.get('api') + '/aeronave/modelo/versao/itens/versao/' + self.props.aircraft_model_version_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ itens_list: responseJson.data });
          }
        })
        .then(() => {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.props.handleMessage();
        });
    });
  }

  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_version_id: this.state.aircraft_model_version_id,
      name: this.state.name,
      type: this.state.type,
    };
    if (this.state.type === 'options') {
      var options = (this.state.options || []).map(function(option) {
        return option ? option.trim() : '';
      }).filter(function(option) {
        return option !== '';
      });
      if (options.length === 0) {
        this.props.handleAlert(this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.MensagemInformeOpcao, 'error', 'open');
        return;
      }
      datasave.options = options;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/aeronave/modelo/versao/item', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          var data_temp = self.state.itens_list;
          data_temp.push(responseJson.data);
          self.setState({ name: '', type: '', itens_list: data_temp, options: [''] });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  delete(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse item?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(config.get('api') + '/aeronave/modelo/versao/item/' + id, {
          method: 'DELETE',
          mode: 'cors',
          headers: value,
        })
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(id);
              self.props.updateData(responseJson);
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
  }

  deleteRow(id) {
    var data = this.state.itens_list;
    data.map(function (dado, index) {
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({ itens_list: data });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.titulo}</h3>
        <div className="clearfix"></div>
        <hr />
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.Tipo}</label>
                <Select
                  className="form-group"
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.placeholder.SelecionarTipo}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={[
                    { value: 'number', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.options.Tipo.Numero },
                    { value: 'text', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.options.Tipo.Texto },
                    { value: 'hour', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.options.Tipo.Horas },
                    { value: 'decimal', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.options.Tipo.Decimais },
                    { value: 'options', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.options.Tipo.Opcoes },
                  ]}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.Nome}</label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.name}
                  name="name"
                  onChange={this.handleChange.bind(this, 'name')}
                  placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.Nome}
                  required
                />
              </div>
          </div>
        </div>
        {this.state.type === 'options' && (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.Opcoes}</label>
                {this.state.options.map((option, index) => (
                  <div className="input-group" style={{ marginBottom: '5px' }} key={'custom-option-' + index}>
                    <input
                      type="text"
                      className="form-control"
                      value={option}
                      onChange={(event) => this.handleOptionChange(index, event)}
                      placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.PlaceholderOpcao}
                    />
                    <span className="input-group-btn">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => this.removeOptionRow(index)}
                        disabled={this.state.options.length <= 1}
                      >
                        <i className="fa fa-fw fa-trash"></i>
                      </button>
                    </span>
                  </div>
                ))}
                <button type="button" className="btn btn-default" onClick={this.addOptionRow}>
                  <i className="fa fa-fw fa-plus"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.BotaoAdicionarOpcao}
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary">
                  <i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.formulario.BotaoCadastrarItem}
                </button>
              </div>
            </div>
          </div>
        </form>
        <hr />
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.tabela.titulo}</caption>
            <thead>
              <tr>
                <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.tabela.Nome}</th>
                <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.tabela.Tipo}</th>
                <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.tabela.Opcoes}</th>
                <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.tabela.Acoes}</th>
              </tr>
            </thead>
            <tbody id="itens">
              {Object.keys(self.state.itens_list).map(function (k) {
                var item = self.state.itens_list[k];
                return (
                  <tr className="text-center" key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.type}</td>
                    <td>{Array.isArray(item.options) && item.options.length > 0 ? item.options.join(', ') : '-'}</td>
                    <td>
                      <button className="btn btn-sm btn-danger" value={item.id} onClick={self.delete}>
                        <i className="fa fa-fw fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftModelVersionCustomItemsTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftModels/Elements/AircraftModelVersionCustomItemsTab.js